// frontend/src/pages/MainPage.jsx
import React, { useState } from "react";

export default function MainPage() {
  const [token, setToken] = useState("");
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [generated, setGenerated] = useState(false);

  const generateToken = async () => {
    try {
      setLoading(true);
      setToken("");
      setGenerated(false);

      const length =
        parseInt(document.querySelector('input[type="number"]').value, 10) || 32;

      const checkboxes = document.querySelectorAll(
        ".checkbox-group input[type='checkbox']"
      );
      const [
        lowercase,
        uppercase,
        digits,
        specials,
        weather_enabled,
        geometry_enabled,
      ] = Array.from(checkboxes).map((c) => c.checked);

      const res = await fetch("/api/generate_token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          length,
          options: { lowercase, uppercase, digits, specials },
          weather_enabled,
          geometry_enabled,
        }),
      });

      const data = await res.json();

      if (res.ok && data.token) {
        setToken(data.token);
        setCopied(false);
        setGenerated(true);
      } else if (data.error?.includes("météo")) {
        setToken("⚠️ API météo indisponible. Token généré sans météo.");
        setGenerated(true);
      } else {
        setToken(`❌ Erreur: ${data.error || "Impossible de générer le token"}`);
        setGenerated(false);
      }
    } catch (err) {
      setToken(`❌ Erreur réseau: ${err.message}`);
      setGenerated(false);
    } finally {
      setLoading(false);
    }
  };

  const copyToken = () => {
    navigator.clipboard.writeText(token);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="card">
      <h1>Nombre Aléatoire Généré</h1>

      <div className="input-group">
        <label>Longueur du Token (8-128)</label>
        <input type="number" defaultValue={128} min={8} max={128} />
      </div>

      <div className="checkbox-group">
        <label><input type="checkbox" defaultChecked /> Minuscules</label>
        <label><input type="checkbox" /> Majuscules</label>
        <label><input type="checkbox" /> Chiffres</label>
        <label><input type="checkbox" defaultChecked /> Symboles</label>
        <label><input type="checkbox" /> Utiliser API météo</label>
        <label><input type="checkbox" defaultChecked /> Utiliser Géométrie</label>
      </div>

      <div className="output-group">
        <textarea
          className="token-box"
          value={loading ? "⏳ Génération en cours..." : token}
          readOnly
          placeholder="Token généré..."
        />
        <button
          className="copy-button"
          onClick={copyToken}
          disabled={!token || loading}
        >
          Copier
        </button>
      </div>

      {copied && <div className="feedback">✅ Token copié avec succès</div>}

      <button
        className="generate-button"
        onClick={generateToken}
        disabled={loading}
      >
        {loading ? "⏳ En cours..." : "Générer"}
      </button>

      {generated && <div className="feedback">✅ Token généré avec succès</div>}
    </div>
  );
}
